module.exports = __webpack_public_path__ + "img/sticker_3.dd8e6b84.svg";